var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigationArrowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 6,
    "view-box": "0 0 4 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.55586 2.99796L0.0901743 0.532276C0.0327668 0.474873 0.00407093 0.403121 0.00407093 0.317017C0.00407093 0.230914 0.0327668 0.156552 0.0901743 0.0939309C0.152795 0.0313103 0.227157 0 0.31326 0C0.399364 0 0.473726 0.0313103 0.536347 0.0939309L3.11162 2.66921C3.15859 2.71617 3.19251 2.76835 3.21338 2.82576C3.23425 2.88316 3.24469 2.94056 3.24469 2.99796C3.24469 3.05537 3.23425 3.11276 3.21338 3.17017C3.19251 3.22758 3.15859 3.27976 3.11162 3.32672L0.528519 5.90983C0.465898 5.97245 0.392836 6.00246 0.309347 5.99984C0.225858 5.99723 0.152795 5.96462 0.0901743 5.902C0.0327668 5.83938 0.00277154 5.76631 0.00015713 5.68283C-0.00245728 5.59934 0.0275536 5.52627 0.0901743 5.46365L2.55586 2.99796Z",
    fill: "#6B7280"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationArrowIcon);
export default __webpack_public_path__ + "static/media/navigationArrowIcon.29b9e6c2bd6d5bbcfe63674ff0f5d92a.svg";
export { ForwardRef as ReactComponent };